import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import { Combobox } from '@salesforce/design-system-react';

import './AttributeChartFilter.scss';
import * as StringUtils from '../../../utilities/stringUtils';

class AttributeChartFilter extends Component {
  componentDidUpdate(prevProps) {
    // attribute filter changed, so load the first of the appropriate attribute value
    if (
      prevProps?.attributeValues?.[0] !== this.props?.attributeValues?.[0] &&
      this.props.attributeValues
    ) {
      this.props.actions.modifyAttributeFilters({
        ...this.props.attributeFilters,
        byValue: this.props.attributeValues[0]
      });
      this.props.actions.getPerformance(this.props.filter, {
        ...this.props.attributeFilters,
        byValue: this.props.attributeValues[0]
      });
    }
  }

  handleAttributeFilterSelection(evt, data) {
    const attributeFilter =
      data?.selection?.[0]?.id === 'none' ? null : data?.selection?.[0]?.id;
    if (data?.selection[0]) {
      if (attributeFilter !== null) {
        this.props.actions.modifyAttributeFilters({
          ...this.props.attributeFilters,
          byAttribute: attributeFilter
        });
        this.props.actions.getAssetAttributeValues(attributeFilter);
      } else {
        this.props.actions.modifyAttributeFilters({
          byAttribute: attributeFilter,
          byValue: attributeFilter
        });
        this.props.actions.getAssetAttributeValues(attributeFilter);
        this.props.actions.getPerformance(this.props.filter, {
          byAttribute: attributeFilter,
          byValue: attributeFilter
        });
      }
    }
  }

  handleAttributeValueSelection(evt, data) {
    const attributeValue =
      data?.selection?.[0]?.id === 'none' ? null : data?.selection?.[0]?.id;
    if (data?.selection[0]) {
      this.props.actions.modifyAttributeFilters({
        ...this.props.attributeFilters,
        byValue: attributeValue
      });
    }
    this.props.actions.getPerformance(this.props.filter, {
      ...this.props.attributeFilters,
      byValue: attributeValue
    });
  }

  attributeFilterOptions() {
    if (this.props.assetKeys) {
      const updatedKeys = this.optionsWithNone(
        this.optionsWithEctTags(this.props.assetKeys)
      );
      return updatedKeys.map(key => this.optionFromKey(key));
    } else {
      return [];
    }
  }

  attributeValueOptions() {
    if (this.props.attributeValues) {
      const updatedKeys = this.optionsWithNone(this.props.attributeValues);
      return updatedKeys.map(key => this.optionFromKey(key));
    } else {
      return [];
    }
  }

  optionFromKey(key) {
    let label = key;
    if (label === 'none') {
      label = this.props.intl.formatMessage({
        id: 'components.ecs.analytics.assetAttribute.attributeFilter.none'
      });
    } else if (label === 'ect_tags') {
      label = this.props.intl.formatMessage({
        id: 'components.ecs.analytics.assetAttribute.attributeFilter.ect_tags'
      });
    }
    return {
      id: key,
      label
    };
  }

  selectedAttributeOption(option) {
    return option ? [this.optionFromKey(option)] : [];
  }

  optionsWithNone(options) {
    if (options) return ['none', ...options];
    return [];
  }

  optionsWithEctTags(options) {
    if (options && this.props.rules?.data?.rules?.settings?.ect) {
      return ['ect_tags', ...options].sort(
        StringUtils.sortStrings(this.props.intl.locale)
      );
    }
    return options || [];
  }

  render() {
    const { attributeFilters } = this.props;
    const { formatMessage } = this.props.intl;

    return (
      <React.Fragment>
        <Combobox
          id="combobox-readonly-single-attr-filter"
          classNameContainer="attribute-filter-container"
          events={{
            onSelect: this.handleAttributeFilterSelection.bind(this)
          }}
          labels={{
            label: (
              <div className="attribute-label">
                {formatMessage({
                  id:
                    'components.ecs.analytics.assetAttribute.attributeFilter.label'
                })}
              </div>
            ),
            placeholderReadOnly: formatMessage({
              id:
                'components.ecs.analytics.assetAttribute.attributeFilter.placeholder'
            })
          }}
          options={this.attributeFilterOptions()}
          selection={this.selectedAttributeOption(attributeFilters.byAttribute)}
          variant="readonly"
        />
        <Combobox
          id="combobox-readonly-single-attr-selection"
          classNameContainer="attribute-filter-container"
          events={{
            onSelect: this.handleAttributeValueSelection.bind(this)
          }}
          labels={{
            label: (
              <div className="attribute-label">
                {formatMessage({
                  id:
                    'components.ecs.analytics.assetAttribute.attributeValueFilter.label'
                })}
              </div>
            ),
            placeholderReadOnly: formatMessage({
              id:
                'components.ecs.analytics.assetAttribute.attributeValueFilter.placeholder'
            })
          }}
          isOpen={this.props.attributeValues ? undefined : false}
          options={this.attributeValueOptions()}
          selection={this.selectedAttributeOption(attributeFilters.byValue)}
          variant="readonly"
        />
      </React.Fragment>
    );
  }
}

AttributeChartFilter.propTypes = {
  assetKeys: PropTypes.array,
  filter: PropTypes.object,
  attributeFilters: PropTypes.object,
  actions: PropTypes.object,
  attributeValues: PropTypes.array
};

export default injectIntl(AttributeChartFilter);
